<div class="ni-library">
  <div class="ni-cat-bar">
    <button [class.active]="activeCategory === ''" (click)="activeCategory = ''">All</button>
    <button *ngFor="let name of categoryNames"
            [class.active]="activeCategory === name"
            (click)="activeCategory = name">{{ name }}</button>
  </div>

  <p class="ni-msg" *ngIf="visibleLikes.length === 0">
    No liked items here yet. Hit &hearts; on anything in the Stream.
  </p>

  <div class="ni-like-row" *ngFor="let like of visibleLikes; trackBy: trackByLikeId">
    <app-ni-feed-item [item]="toCard(like)"
      (open)="open.emit(like)"
      (toggleLike)="unlike.emit(like)"></app-ni-feed-item>
    <div class="ni-like-cat">
      <span class="ni-cat-tag">{{ like.category || 'Uncategorized' }}</span>
      <button (click)="recategorize.emit(like)">Re-file</button>
    </div>
  </div>
</div>
